import React from 'react';
import jwtDecode from 'jwt-decode';
import api from 'api';
import moment from 'moment';
import { AppLink } from '../../../routing/containers';
import { Tabs, Tab } from 'react-bootstrap';
import { Spinner, Modal, AlertMessage } from 'hyperdb-utils';
import {
  CustomerDetails, ReservationInfo, ReservationExtraInfos, ReservationGuestsDetails, ReservationPricesDetails, ReservationRemarksContainer, ModalEmailAction
} from '../../common';
import ItemActions from './ItemActions';
import { Payments } from '../../payment/containers';
import { Calendar } from '../../availabilities/containers';
import { MessagesHistory } from '../../../email/message/containers';

class Show extends React.Component {
  constructor(props) {
    super(props);
    this.handleClickBack = this.handleClickBack.bind(this);
    this.handleCustomerUpdated = this.handleCustomerUpdated.bind(this);
    this.handleToggleModalExtraInfo = this.handleToggleModalExtraInfo.bind(this);
    this.handleChangeExtraInfo = this.handleChangeExtraInfo.bind(this);
    this.handleSaveExtraInfo = this.handleSaveExtraInfo.bind(this);
    this.handlePaymentsChanged = this.handlePaymentsChanged.bind(this);
    this.handleToggleModalPriceParams = this.handleToggleModalPriceParams.bind(this);
    this.handleChangePriceParams = this.handleChangePriceParams.bind(this);
    this.handleSavePriceParams = this.handleSavePriceParams.bind(this);
    this.handleToggleModalRecalculate = this.handleToggleModalRecalculate.bind(this);
    this.handleRecalculate = this.handleRecalculate.bind(this);
    this.handleOnActionSuccessful = this.handleOnActionSuccessful.bind(this);
  }
  componentDidMount() {
    this.props.api.reservation.getObject(this.props.params.id);
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.deleteSuccessful) {
      this.props.api.routing.redirect(this.props.router, '/daily-rental/reservations');
    }
    if (nextProps.actionSuccessful) {
      const action = nextProps.selectedAction;
      this.props.api.reservation.setData({ selectedAction: null, actionSuccessful: false });
      this.props.api.reservation.getObject(this.props.params.id)
        .then(() => {
          if (action !== 'remove_error') {
            this.props.api.reservation.setData({ successMessage: 'Action done' });
          }
        });
    }
  }
  componentWillUnmount() {
    this.props.api.reservation.setData({
      deleteSuccessful: false,
      showModalDelete: false,
      successMessage: null,
      errorMessage: null,
      selectedAction: null,
      actionSuccessful: false,
    });
  }
  render() {
    if (!this.props.objectData) return <div className="box box-primary"><Spinner show={ true } /></div>;
    const reservation = this.props.objectData || {};
    const customer = reservation.customer || {};
    const showPayments = reservation.status === 'accepted' || reservation.status === 'confirmed' || reservation.status === 'canceled';
    const messages = this.props.api.getState('message').relatedMessages || [];
    const lastReceivedMessage = messages.find(m => m.folder === 'inbox') || {};
    return (
      <div className="content-wrapper">
        <section className="content-header content-header-fixed">
          <div className="row">
            <div className="col-md-7">
              <span className="btn btn-sm btn-primary" onClick={ this.handleClickBack }>
                <i className="fas fa-chevron-left"></i> Back
              </span>
              &nbsp; <h3 className="box-title">Show reservation</h3>
            </div>
          </div>
        </section>
        <section className="content content-fixed">
          {
            this.props.successMessage
              ? <AlertMessage
                  type="success"
                  onDismiss={ this.props.api.reservation.dismissAlert }>
                    { this.props.successMessage }
                </AlertMessage>
              : null
          }
          <div className="box box-primary">
            <Spinner show={ this.props.loading } />
            <div className="box-body show-booking">
              <div className="row">
                <div className="col-lg-5">
                  <fieldset>
                    <legend className="box-header">
                      RESERVATION #{ reservation.reference }&nbsp;
                      <ItemActions
                        { ...this.props }
                        reservation={ reservation }
                        onActionSuccessful={ this.handleOnActionSuccessful }
                        repliedMessageId={ lastReceivedMessage.id }
                      />
                    </legend>
                    <ReservationInfo reservation={ reservation } customer={ customer } showDeposit={ true } />
                    <ReservationExtraInfos
                      reservation={ reservation }
                      toggleModal={ this.handleToggleModalExtraInfo }
                      showModal={ this.props.showModalExtraInfo }
                      editedExtraInfo={ this.props.editedExtraInfo }
                      onChange={ this.handleChangeExtraInfo }
                      onSave={ this.handleSaveExtraInfo }
                    />
                    <ReservationRemarksContainer
                      { ...this.props }
                      reservation={ reservation }
                      type="reservation"
                      api={ this.props.api }
                    />
                  </fieldset>
                </div>
                <div className="col-lg-7">
                  <Tabs defaultActiveKey={1} id="tabs-details">
                    <Tab eventKey={1} title="Details">
                      <br/>
                      <CustomerDetails customer={ customer} onCustomerUpdated={ this.handleCustomerUpdated } />
                      <div className="row">
                        <div className="col-lg-6">
                          <ReservationGuestsDetails reservation={ reservation } />
                        </div>
                        <div className="col-lg-6">
                          <ReservationPricesDetails
                            reservation={ reservation }
                            loading={ this.props.loading }
                            extraInfo={ true }
                            toggleModal={ this.handleToggleModalPriceParams }
                            showModal={ this.props.showModalPriceParams }
                            editedPriceParams={ this.props.editedPriceParams }
                            onChange={ this.handleChangePriceParams }
                            onSave={ this.handleSavePriceParams }
                            toggleModalRecalculate={ this.handleToggleModalRecalculate }
                            showModalRecalculate={ this.props.showModalRecalculate }
                            onRecalculate={ this.handleRecalculate }
                          />
                        </div>
                      </div>
                    </Tab>
                    <Tab eventKey={2} title="History">
                      <br/>
                      <MessagesHistory reference={ reservation.reference } type="reservation" reload={ this.props.actionSuccessful } />
                    </Tab>
                    {
                      showPayments
                        ? <Tab eventKey={3} title="Payments">
                            <br/>
                            <Payments reservation={ reservation } onChange={ this.handlePaymentsChanged } />
                          </Tab>
                        : null
                    }
                    <Tab eventKey={4} title="Calendar">
                      <Calendar booking={ reservation } noFilters={ true } contentOnly={ true } />
                    </Tab>
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }

  handleClickBack() {
    if (window.previousLocation) {
      this.props.router.push(window.previousLocation);
    } else {
      this.props.api.routing.redirect(this.props.router, '/daily-rental/reservations');
    }
  }
  handleCustomerUpdated(customer) {
    this.props.api.reservation.getObject(this.props.params.id);
  }

  handleToggleModalExtraInfo(bool) {
    const editedExtraInfo = { ...this.props.objectData };
    this.props.api.reservation.setData({ showModalExtraInfo: bool, editedExtraInfo });
  }
  handleChangeExtraInfo(extraInfo) {
    this.props.api.reservation.setData({ editedExtraInfo: extraInfo });
  }
  handleSaveExtraInfo() {
    const params = this.props.editedExtraInfo;
    const extraInfo = {
      confirmation_printed: params.confirmation_printed,
      arrival_transport: params.arrival_transport,
      departure_transport: params.departure_transport,
      leave_keys: params.leave_keys,
      parking_reserved: params.parking_reserved,
      arrival_time: params.arrival_time,
      departure_time: params.departure_time,
    };
    this.props.api.reservation.submitEditForm({ objectData: { ...extraInfo, _patch: true }, id: this.props.objectData.id });
    this.props.api.reservation.updateEditedObject({ data: { ...this.props.objectData, ...extraInfo } });
    this.props.api.reservation.setData({ showModalExtraInfo: false });
  }
  handleToggleModalPriceParams(bool) {
    const editedPriceParams = { ...this.props.objectData, cleaning_fee: this.props.objectData.cleaning_fee_original, tourist_tax: this.props.objectData.tourist_tax_original };
    this.props.api.reservation.setData({ showModalPriceParams: bool, editedPriceParams });
  }
  handleChangePriceParams(params) {
    this.props.api.reservation.setData({ editedPriceParams: params });
  }
  handleSavePriceParams() {
    const params = this.props.editedPriceParams;
    const updatedAttributes = {
      price: params.price || 0,
      deposit: params.deposit || 0,
      disableVAT: params.disableVAT,
      disable_cleaning_fee: params.disable_cleaning_fee,
      disable_tourist_tax: params.disable_tourist_tax,
    };
    if (!params.disable_cleaning_fee) updatedAttributes.cleaning_fee = params.cleaning_fee || 0;
    if (!params.disable_tourist_tax) updatedAttributes.tourist_tax = params.tourist_tax || 0;
    this.props.api.reservation.submitEditForm({ objectData: { ...updatedAttributes, _patch: true }, id: this.props.objectData.id })
      .then(() => {
        this.props.api.reservation.setData({ showModalPriceParams: false });
        this.props.api.reservation.getObject(this.props.params.id);
      });
  }
  handleToggleModalRecalculate(bool) {
    this.props.api.reservation.setData({ showModalRecalculate: bool });
  }
  handleRecalculate() {
    this.props.api.reservation.postData({
      url: `/${this.props.objectData.id}/recalculate`,
      data: {},
    })
    .then(() => {
      this.props.api.reservation.setData({ showModalRecalculate: false });
      this.props.api.reservation.getObject(this.props.params.id);
    });
  }

  handlePaymentsChanged() {
    this.props.api.reservation.getObject(this.props.params.id);
  }

  handleOnActionSuccessful() {
    this.props.api.reservation.getObject(this.props.params.id)
      .then(() => {
        this.props.api.reservation.setData({ successMessage: 'Action done' });
      });
  }
}

export default api.connect(Show, 'reservation');



// WEBPACK FOOTER //
// ./src/frontend/modules/daily-rental/reservation/containers/Show.jsx